export default "__VITE_PUBLIC_ASSET__84078a5a__"